<template>
    <div class="space-y-32" v-in-viewport="fetchJobs">
        <graph-title
            :show-tooltip="false"
            :title="$t('analytics.insights.recruitment_process.stages.title')"
            :description="$t('analytics.insights.recruitment_process.stages.description')"
        >
            <select-dropdown
                v-model="selectedJobId"
                :auto-translate="false"
                :loading="false"
                :options="jobs"
                :placeholder="$t('placeholders.jobs').toString()"
                class="w-1/4 mr-12"
                searchable
            ></select-dropdown>
        </graph-title>
        <div>
            <div v-if="fetching" class="h-336 w-full flex items-center justify-center">
                <loading color="blue" size="small"></loading>
            </div>
            <div v-else class="space-y-32">
                <div :class="defaultCardClasses">
                    <graph-title
                        :show-tooltip="false"
                        :title="$t('analytics.insights.recruitment_process.stages.applicants.title')"
                        :description="$t('analytics.insights.recruitment_process.stages.applicants.description')"
                    ></graph-title>
                    <div v-if="!selectedJobId" class="flex flex-col px-10">
                        <span class="text-center italic my-16">{{ $t('analytics.stages.empty_series.in_stage') }}</span>
                    </div>
                    <div v-else class="h-360 relative">
                        <custom-legend
                            :clickable="true"
                            :colors="tabs.map(tab => getTabColor(tab))"
                            :items="tabs"
                            :selected-tab="selectedTab1"
                            translation-key="timeline"
                            parent-ref="chart1Ref"
                            @update="handleUpdateChart1"
                        />
                        <apex-charts
                            ref="chart1"
                            :options="chartOptions"
                            :series="series"
                            height="100%"
                            width="100%"
                        ></apex-charts>
                    </div>
                </div>
                <div :class="defaultCardClasses">
                    <graph-title
                        :show-tooltip="false"
                        :title="$t('analytics.insights.recruitment_process.stages.lead_time.title')"
                        :description="$t('analytics.insights.recruitment_process.stages.lead_time.description')"
                    ></graph-title>
                    <div v-if="!selectedJobId" class="flex flex-col px-10">
                        <span class="text-center italic my-16">{{
                                $t('analytics.stages.empty_series.avg_lead_time')
                            }}</span>
                    </div>
                    <div v-else>
                        <div class="h-360 relative">
                            <apex-charts
                                ref="chart2"
                                :options="chartOptions2"
                                :series="series2"
                                height="100%"
                                width="100%"
                            ></apex-charts>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as analytics from '../../services/AnalyticsService';
import analyticsMixins from "../../mixins/analyticsMixins";
import GraphTitle from "./GraphTitle";
import ApexCharts from "vue-apexcharts";
import chartOptions from '../../config/apex-charts';
import Loading from "../ui/Loading";
import CustomLegend from "./CustomLegend.vue";
import SelectDropdown from "../forms/SelectDropdown.vue";

export default {
    name: 'Stages',
    components: {
        SelectDropdown,
        CustomLegend,
        Loading,
        ApexCharts,
        GraphTitle,
    },
    mixins: [analyticsMixins],
    props: {
        defaultCardClasses: {type: String},
        filterFields: Object,
    },
    data() {
        return {
            selectedJobId: null,

            chartOptions: this.getChartOptions(1),
            chartOptions2: this.getChartOptions(2),
            series: [],
            series2: [],

            tabs: ['rejected', 'active'],
            selectedTab1: null,

            jobs: [],
            graphData: null,
        }
    },
    methods: {
        getTabColor(tab) {
            return this.chartOptions.colors[this.tabs.indexOf(tab)];
        },
        fetchJobs(fresh = true) {
            if (!this.sendRequest() && !fresh) {
                this.fetching = false;
                return;
            }
            analytics.jobList(this.filterFields).then(response => {
                this.jobs = response;
            })
        },
        fetchData() {
            if (!this.selectedJobId) {
                this.fetching = false;
                return;
            }
            analytics.stages(this.filterFields, this.selectedJobId).then(response => {
                this.graphData = response;
            }).finally(() => this.buildChart());
        },
        buildChart() {
            // first empty out everything
            this.series = [];
            this.series2 = [];
            this.chartOptions.xaxis.categories = [];
            this.chartOptions2.xaxis.categories = [];

            this.series = JSON.parse(JSON.stringify(this.graphData.data.data[0]));
            this.series2 = [JSON.parse(JSON.stringify(this.graphData.data.data[1]))];
            this.chartOptions.xaxis.categories = this.graphData.data.categories;
            this.chartOptions2.xaxis.categories = this.graphData.data.categories;

            this.fetching = false;
            this.$nextTick(() => {
                this.graphRef1 = this.$refs.chart1;
                this.setDownloadButtonId(this.graphRef1, 'downloadChartNumberApplicants');
                this.graphRef2 = this.$refs.chart2;
                this.setDownloadButtonId(this.graphRef2, 'downloadChartAverageLeadTime');
            })
        },
        handleUpdateChart1(value) {
            if (this.selectedTab1 === value) {
                this.selectedTab1 = null;
                return;
            }
            this.selectedTab1 = value;
        },
        getChartOptions(chart) {
            let graphData = {
                ...chartOptions,
                chart: {
                    ...chartOptions.chart,
                },
                plotOptions: {
                    ...chartOptions.plotOptions,
                    bar: {
                        ...chartOptions.plotOptions.bar,
                        horizontal: false,
                    }
                },
                xaxis: {
                    categories: [],
                },
                legend: {
                    show: false,
                },
            };
            if (chart === 1) {
                graphData.colors = [
                    '#FF4560', '#00E396'
                ];
            }
            return graphData;
        },
    },
    watch: {
        filterFields() {
            this.fetchJobs()
        },
        selectedJobId() {
            if (!!this.selectedJobId) {
                this.fetching = true;
                this.fetchData();
            }
        },
    },
    mounted() {
        this.fetching = false;
    }
}
</script>
